import { render, staticRenderFns } from "./main-staff-enableUpc.vue?vue&type=template&id=4685667b&scoped=true"
import script from "./main-staff-enableUpc.vue?vue&type=script&lang=js"
export * from "./main-staff-enableUpc.vue?vue&type=script&lang=js"
import style0 from "./main-staff-enableUpc.vue?vue&type=style&index=0&id=4685667b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4685667b",
  null
  
)

export default component.exports